import { useState, useEffect } from "react";
import styled from "styled-components";
import { ReactComponent as IconPlus } from "../Images/icon_plus.svg";

export const LogoRegister = ({ initialLogo, onSetLogo, step = null }) => {
  const [renderLogo, setRenderLogo] = useState("");

  const handleFileUpload = (e) => {
    let fileArr = e.target.files;

    if (fileArr.length > 0) {
      const fileRead = new FileReader();
      fileRead.onload = function () {
        setRenderLogo(fileRead.result);
      };

      fileRead.readAsDataURL(fileArr[0]);

      onSetLogo(fileArr[0]);
    }
  };

  useEffect(() => {
    if (initialLogo) setRenderLogo(initialLogo);
  }, [initialLogo]);

  const deleteFileUpload = () => {
    setRenderLogo("");
    onSetLogo(null);
  };

  return (
    <div name="area wrapper">
      {renderLogo ? (
        <PreviewBox step={step}>
          {step ? (
            <div style={{ width: "400px", height: "97px" }}>
              <img
                src={renderLogo}
                alt="logo"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          ) : (
            <img src={renderLogo} alt="logo" />
          )}
          <div className="buttonWrapper">
            <div className="deleteBtn center" onClick={deleteFileUpload}>
              삭제
            </div>
            <div className="reuploadBtn center" onChange={handleFileUpload}>
              <label htmlFor="registerBtn" style={{ cursor: "pointer" }}>
                다시 업로드
              </label>
              <input
                type="file"
                accept="image/*"
                id="registerBtn"
                style={{ display: "none" }}
              />
            </div>
          </div>
        </PreviewBox>
      ) : (
        <div name="area wrapper">
          <LogoRegisterBtn onChange={handleFileUpload}>
            <label htmlFor="registerBtn"></label>
            <input type="file" accept="image/*" id="registerBtn" />
            <IconPlus width="24px" height="24px" stroke="#222222" />
            <p style={{ margin: 0, marginTop: "-2px" }}>로고 등록</p>
          </LogoRegisterBtn>
        </div>
      )}
    </div>
  );
};

const LogoRegisterBtn = styled.div`
  width: 400px;
  height: 80px;
  margin-top: 30px;
  box-shadow: 0 0 0 1px #b0b0b0 inset;
  border-radius: 10px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  > img {
    width: 24px;
    height: 24px;
  }
  > p {
    font-size: 16px;
    color: #222222;
    font-family: "notoSans-medium";
  }
  > input {
    display: none;
  }
  > label {
    width: 400px;
    height: 80px;
    position: absolute;
    cursor: pointer;
  }
  &:hover {
    background-color: #f2f2f2;
  }
`;

const PreviewBox = styled.div`
  width: ${(props) => (props.step === "step2" ? "400px" : "240px")};
  height: auto;
  margin-top: 30px;
  display: inline-block;
  justify-content: center;
  align-items: center;
  > img {
    width: 240px;
    height: 240px;
    border-radius: 10px;
    object-fit: cover;
  }
  .buttonWrapper {
    display: flex;
    flex-direction: block;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
  }
  .deleteBtn {
    width: 46px;
    height: 36px;
    font-family: "notoSans-medium";
    font-size: 14px;
    color: #f25c5c;
    cursor: pointer;
  }
  .reuploadBtn {
    width: 88px;
    height: 36px;
    margin-left: 8px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 0 0 1px #b0b0b0 inset;
    font-family: "notoSans-medium";
    font-size: 14px;
    color: #222222;
    cursor: pointer;
  }
`;
